import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicPageReviewComponent } from './dynamic-page-review/dynamic-page-review.component';
import { StandardPageReviewRendererComponent } from './standard-page-review-renderer/standard-page-review-renderer.component';
import { PageResolverModule } from '../resolver/page-resolver.module';
import { CardReviewModule } from '../../card/review/card-review.module';
import { PageReviewCardsComponent } from './page-review-cards/page-review-cards.component';

const components = [DynamicPageReviewComponent, StandardPageReviewRendererComponent];

@NgModule({
  declarations: [...components, PageReviewCardsComponent],
  exports: [...components],
  imports: [CommonModule, PageResolverModule, CardReviewModule]
})
export class PageReviewModule {}
